import { animate, style, transition, trigger } from '@angular/animations';

export const FadeInOut = trigger('fadeInOut', [
  transition(':enter', [style({ opacity: 0 }), animate('0.2s', style({ opacity: 0.7 }))]),
  transition(':leave', [animate('0.2s', style({ opacity: 0 }))]),
]);

export function fadeInOut(duration: number) {
  return trigger('fadeInOut', [
    transition(':enter', [style({ opacity: 0 }), animate(duration, style({ opacity: 0.7 }))]),
    transition(':leave', [animate(duration, style({ opacity: 0 }))]),
  ]);
}

export const FadeInOutDelayed = trigger('fadeInOutDelayed', [
  transition(':enter', [style({ opacity: 0 }), animate('0.1s 0.1s', style({ opacity: 1 }))]),
  transition(':leave', [animate('0.1s', style({ opacity: 0 }))]),
]);

export const SlideInOut = trigger('slideInOut', [
  transition(':enter', [
    style({ transform: 'translateY(-10px)', opacity: 0 }),
    animate('0.2s', style({ transform: 'translateY(0)', opacity: 1 })),
  ]),
]);
